<template>
  <div class="Crisis_evaluation_view">
    <el-descriptions class="margin-top" :column="4"  border>

      <el-descriptions-item>
        <template slot="label">
          姓名
        </template>
        {{ datas.RealName }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          性别
        </template>
        {{ sex == 1?'男':'女' }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          年龄
        </template>
        {{ age }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          学号
        </template>
        {{ userId }}
      </el-descriptions-item>

      <el-descriptions-item span="3">
        <template slot="label">
          近期情绪状态如何
        </template>
        {{ sys_Forms[1].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          持续时间
        </template>
        {{ sys_Forms[2].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item span="3">
        <template slot="label">
          现实事件刺激影响
        </template>
        {{ sys_Forms[5].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          有无自杀自伤想法或行为
        </template>
        <div v-for="(item, i) in sys_Forms[7].Bobbies" :key="i">
          <span v-if="sys_Forms[7].FormValue == item.Value">
            {{ item.Name }}
          </span>
        </div>
      </el-descriptions-item>

      <el-descriptions-item span="4">
        <template slot="label">
          自杀自伤想法或行为
        </template>
        {{ sys_Forms[7].Bobbies[1].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item span="3">
        <template slot="label">
          保护因素
        </template>
        {{ sys_Forms[8].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          自杀危机状态
        </template>
        <div v-for="(item, i) in sys_Forms[9].Bobbies" :key="i">
          <span v-if="sys_Forms[9].FormValue == item.Value">
            {{ item.Name }}
          </span>
        </div>
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">
          精神疾病治疗史
        </template>
        <div v-for="(item, i) in sys_Forms[12].Bobbies" :key="i">
          <span v-if="sys_Forms[12].FormValue == item.Value">
            {{ item.Name }}
          </span>
        </div>
      </el-descriptions-item>

      <el-descriptions-item span="3">
        <template slot="label">诊断结果</template>
        {{ sys_Forms[13].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item span="4">
        <template slot="label">治疗情况</template>
        {{ sys_Forms[14].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item span="3">
        <template slot="label">家族史</template>
        {{ sys_Forms[15].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item>
        <template slot="label">是否有物质依赖</template>
        <div v-for="(item, i) in sys_Forms[16].Bobbies" :key="i">
          <span v-if="sys_Forms[16].FormValue == item.Value">
            {{ item.Name }}
          </span>
        </div>
      </el-descriptions-item>

      <el-descriptions-item span="2">
        <template slot="label">是否愿意寻求心理咨询帮助</template>
        {{ sys_Forms[18].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item span="2">
        <template slot="label">是否愿意就医</template>
        {{ sys_Forms[19].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item span="4">
        <template slot="label">备注</template>
        {{ sys_Forms[20].FormValue }}
      </el-descriptions-item>
      
      <el-descriptions-item span="1">
        <template slot="label">访谈后风险等级</template>
        <div v-for="(item, i) in sys_Forms[22].Bobbies" :key="i">
          <span v-if="sys_Forms[22].FormValue == item.Value">
            {{ item.Name }}
          </span>
        </div>
      </el-descriptions-item> 

      <el-descriptions-item span="3">
        <template slot="label">风险调整原因</template>
        {{ sys_Forms[23].FormValue }}
      </el-descriptions-item>

      <el-descriptions-item span="4">
        <template slot="label">访谈建议</template>
        {{ sys_Forms[25].FormValue }}
      </el-descriptions-item>

    </el-descriptions>

    <div v-if="this.Global.pdroleid(1069) || this.Global.pdroleid(1068) || this.Global.pdroleid(1070)">
      <p style="padding: 20px;">风险监控员初核意见</p>
      <el-checkbox-group style="margin-left: 20px;" :disabled="disabled1" :max="3" v-model="shenhe.riskMonitorChecks">
        <el-checkbox label="1" name="type">信息不完整</el-checkbox>
        <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
        <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
        <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
      </el-checkbox-group>
      <el-input style="padding: 20px;width: 90%;" :disabled="disabled1" type="textarea" v-model="shenhe.riskMonitorCheckDetail"></el-input>
      <div v-if="this.Global.pdroleid(1069)" style="margin-left: 20px;">
        <el-button type="primary" @click="submit(1)">审核确认</el-button>
        <el-button type="primary" @click="submit(2)">审核驳回</el-button>
        <el-button type="primary" @click="submit(3)">提交危机主管</el-button>
      </div>
    </div>
    <div v-if="this.Global.pdroleid(1068) || this.Global.pdroleid(1070)">
      <p style="padding:20px;">危机主管复核意见</p>
      <el-checkbox-group style="margin-left: 20px;" :disabled="disabled2" :max="3" v-model="shenhe.criAdminChecks">
        <el-checkbox label="1" name="type">信息不完整</el-checkbox>
        <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
        <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
        <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
      </el-checkbox-group>
      <el-input style="padding:20px;width:90%;" type="textarea" :disabled="disabled2" v-model="shenhe.criAdminCheckDetail"></el-input>
      <div v-if="this.Global.pdroleid(1068)" style="margin-left: 20px;">
        <el-button type="primary" @click="submit(1)">审核确认</el-button>
        <el-button type="primary" @click="submit(2)">审核驳回</el-button>
        <el-button type="primary" @click="submit(3)">提交中心主任</el-button>
      </div>
    </div>
    <div v-if="this.Global.pdroleid(1068) || this.Global.pdroleid(1070)">
      <p style="padding: 20px;">中心主任审核意见</p>
      <el-checkbox-group style="margin-left: 20px;" :disabled="disabled3" :max="3" v-model="shenhe.centerDirectorChecks">
        <el-checkbox label="1" name="type">信息不完整</el-checkbox>
        <el-checkbox label="2" name="type">填写内容过于简单</el-checkbox>
        <el-checkbox label="3" name="type">实际情况需要进一步确认</el-checkbox>
        <el-checkbox label="4" name="type">等级评定过于乐观</el-checkbox>
      </el-checkbox-group>
      <el-input style="padding: 20px;width: 90%;" :disabled="disabled3" type="textarea" v-model="shenhe.centerDirectorCheckDetail"></el-input>
      <div v-if="this.Global.pdroleid(1070)" style="margin-left: 20px;">
        <el-button type="primary" @click="submit(1)">审核确认</el-button>
        <el-button type="primary" @click="submit(2)">审核驳回</el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      nxkos: [
        { "Value": "PTIR0301001", "FormValue": "", "Name": "无", "FontColor": null, "Display": false },
        { "Value": "PTIR0301002", "FormValue": "", "Name": "有", "FontColor": null, "Display": true }
      ],
      age: '',
      sex: '',
      userId: '',
      PublishID:'',
      UserID: '',
      datas: '',
      keyNo: '',
      sys_Forms: [],
      RoleID: '',
      disabled1: true,
      disabled2: true,
      disabled3: true,
      shangbaotype: '',
      shenhe: {
        riskMonitorChecks: [],//风险监控员审核意见
        riskMonitorCheckDetail: '',//风险监控员审核详细意见
        criAdminChecks: [],//危机主管审核意见
        criAdminCheckDetail: '',//危机主管审核详细意见
        centerDirectorChecks: [],//中心主任审核意见
        centerDirectorCheckDetail: '',//中心主任审核详细意见"
      },
    }
  },
  methods: {
    submit(val) {
      this.$Http_Post('/DistressPrediction/DailyRiskMonitors', {
        keyNo: this.keyNo, type: this.shangbaotype, operate: val,
        riskMonitorChecks: this.shenhe.riskMonitorChecks, riskMonitorCheckDetail: this.shenhe.riskMonitorCheckDetail,
        criAdminChecks: this.shenhe.criAdminChecks, criAdminCheckDetail: this.shenhe.criAdminCheckDetail,
        centerDirectorChecks: this.shenhe.centerDirectorChecks, centerDirectorCheckDetail: this.shenhe.centerDirectorCheckDetail,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.Global.request_successful(res.Message);
          this.$router.push({
            path: '/Crisis/Crisis_upreport'
          })
        }
      });
    },
  },
  mounted() {
    this.PublishID = [this.$route.query.PublishID][0];
    this.UserID = [this.$route.query.UserID][0];
    this.keyNo = [this.$route.query.KeyNo][0];
    this.RoleID = sessionStorage.getItem('RoleID');
    this.shangbaotype = [this.$route.query.type][0]
    if (this.Global.pdroleid(1069)) {
      this.disabled1 = false
    } else if (this.Global.pdroleid(1068)) {
      this.disabled2 = false
    } else if (this.Global.pdroleid(1070)) {
      this.disabled3 = false
    }
    
    this.$Http_Post('/CrisisWarning/GetFormView', { TableName: "新生心理普测访谈记录表", PublishID: this.PublishID, UserID: this.UserID }).then((res) => {
      if (res.Code == 200 || res.Code == 0 && res.Data) {
        this.datas = res.Data;
        this.sys_Forms = res.Data.sys_Forms;
      }
    });

    this.$Http_Post('/DistressPrediction/PrefabricatedTableData', { keyNo: this.keyNo }).then((res) => {
      if (res.Code == 0) {
        this.age = res.Data.age;
        this.sex = res.Data.sex;
        this.userId = res.Data.userId;
        this.shenhe = {
          riskMonitorChecks: res.Data.riskMonitorChecks,//风险监控员审核意见
          riskMonitorCheckDetail: res.Data.riskMonitorCheckDetail,//风险监控员审核详细意见
          criAdminChecks: res.Data.criAdminChecks,//危机主管审核意见
          criAdminCheckDetail: res.Data.criAdminCheckDetail,//危机主管审核详细意见
          centerDirectorChecks: res.Data.centerDirectorChecks,//中心主任审核意见
          centerDirectorCheckDetail: res.Data.centerDirectorCheckDetail,//中心主任审核详细意见"
        }
      }
    });
  }
}

</script>

<style>
.Crisis_evaluation_view{width: 100%;height: 100%;background-color: #fff;overflow: auto;}
.Crisis_evaluation_view .el-descriptions{width: 98%;margin-left: 1%;padding-top: 20px;}
</style>